<template>
  <v-menu v-model="open" rounded="lg" offset-y style="z-index:10000" min-width="200" max-width="400" :close-on-content-click="false">
    <template v-slot:activator="{ attrs, on }">
      <v-btn v-bind="attrs" v-on="on" icon class="mr-2">
        <v-avatar size="36">
          <v-icon>mdi-bell</v-icon>
        </v-avatar>
      </v-btn>
    </template>
    <v-sheet width="400">
      <div v-if="notifs.length===0">
        <alert icon="mdi-information-outline" class="mr-2">
          Не найдено
        </alert>
      </div>
      <div v-else>
        <v-toolbar flat dense class="body-2">
          Уведомлений: {{notifs.length}}
          <v-spacer/>
          <v-btn small depressed color="transparent" @click="removeAll()">
            <v-icon small class="mr-2">mdi-notification-clear-all</v-icon>
            Удалить все
          </v-btn>
        </v-toolbar>
        <v-sheet class="overflow-y-auto overflow-x-hidden" max-height="400">
          <div v-for="notif in notifs" :key="notif.sid">
            <v-toolbar flat dense>
              <chip
                  :color="notif.type==='success' ? 'green' : notif.type==='warning' ? 'orange darken-1' : notif.type==='error' ? 'red' : undefined"
                  :dark="true"
                  small
              >
                <div v-if="notif.type==='success'">Успешно</div>
                <div v-if="notif.type==='warning'">Предупреждение</div>
                <div v-if="notif.type==='error'">Ошибка</div>
              </chip>
              <div class="body-2 ml-2">{{notif.created}}</div>
              <v-spacer/>
              <v-btn icon small @click="remove(notif)"><v-icon small>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <div v-html="$tools.nl2br(notif.text)" class="px-4 pb-2 body-2"></div>
            <v-divider/>
          </div>
        </v-sheet>
      </div>
    </v-sheet>
  </v-menu>
</template>

<script>
import Chip from "@/componentsV2/base/Chip.vue";
import Alert from "@/componentsV2/base/Alert.vue";

export default {
  components: {Alert, Chip},
  data: () => ({
    open:false,
    notifs: []
  }),
  watch: {
    open(v) {
      if (v)
        this.load();
    }
  },
  methods:{
    load(){
      this.notifs = this.$tools.storageArrayGet('notifs');
    },
    remove(v){
      this.notifs = this.$tools.storageArrayRemove('notifs', v.sid);
    },
    removeAll(){
      this.$tools.storageSet('notifs');
      this.open = false;
    }
  }
};
</script>